module.exports = __webpack_public_path__ + "img/planta_08.76af7caf.png";